import { buildExtractUrl } from "../../utils/utils";
import { formatDate } from "../../utils/formatDate";
import type { Book } from "../BookExtracts/types";
import "./BookCard.scss";

interface BookCardProps {
  book: Book;
  index: number;
}

function BookCard({ book, index }: BookCardProps) {
  const extractUrl = buildExtractUrl(book.isbn);

  return (
    <article className="book-card">
      <span className="book-card__index">{index + 1}</span>

      <a
        className="book-card__cover"
        href={extractUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={book.jacketUrl} alt={`Cover of ${book.title}`} loading="lazy" />
      </a>

      <div className="book-card__body">
        <h3 className="book-card__title">
          <a href={extractUrl} target="_blank" rel="noopener noreferrer">
            {book.title}
          </a>
        </h3>
        <p className="book-card__author">{book.author}</p>
        <p className="book-card__meta">
          {book.estimatedReadingTimeMinutes} min read · {formatDate(book.publicationDate)}
        </p>
      </div>

      <p className="book-card__bio">{book.authorBiography}</p>
    </article>
  );
}

export default BookCard;
